function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from "react";
import { Kind } from "@oui/lib/src/types";
import { Button } from "./Button";
import { SliderInput } from "./SliderInput";
import { View } from "./View";
/**
 * A `ChatInput` variant that allows the user to select a numerical value via a
 * slider interface. Slider can be configured to display text labels for
 * specific values.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-71}
 */ export var ChatInputSlider = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(ChatInputSlider, Component);
    function ChatInputSlider() {
        _class_call_check(this, ChatInputSlider);
        var _this;
        _this = _call_super(this, ChatInputSlider, arguments), _define_property(_this, "state", {
            currentValue: _this.props.value || _this.props.minValue
        }), _define_property(_this, "handleSubmit", function() {
            var onInput = _this.props.onInput;
            if (onInput) {
                var value = _this.state.currentValue;
                onInput({
                    kind: Kind.InputSlider,
                    props: value
                });
            }
        });
        return _this;
    }
    _create_class(ChatInputSlider, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var style = this.props.style;
                return /*#__PURE__*/ _jsxs(View, {
                    style: [
                        {
                            paddingTop: 8,
                            paddingLeft: 25,
                            paddingBottom: 8,
                            paddingRight: 25
                        },
                        style
                    ],
                    children: [
                        /*#__PURE__*/ _jsx(SliderInput, _object_spread_props(_object_spread({}, this.props), {
                            onChangeValue: function(v) {
                                return _this.setState({
                                    currentValue: v
                                });
                            }
                        })),
                        /*#__PURE__*/ _jsx(Button, {
                            text: "Choose",
                            onPress: this.handleSubmit,
                            testID: "ChatInputSlider_submit",
                            alignSelf: "center",
                            style: {
                                marginTop: 8
                            }
                        })
                    ]
                });
            }
        }
    ]);
    return ChatInputSlider;
}(Component);
_define_property(ChatInputSlider, "defaultProps", {
    step: 1,
    maxValue: 10,
    minValue: 0,
    onInput: function() {}
});
